import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';

import { breakpoints, colors, fontFamily, zIndex } from '../../ui/variables';

export const AddExamOrthacStyle = styled.main`
  .add-exam-content {
    background-color: ${colors.gray};
    min-height: 100vh;
    padding: ${headerVariables.main.height.iphone + 52}px 16px 52px;
    width: 100%;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      padding: ${headerVariables.main.height.iphone + 116}px 52px 52px 36px;
    }

    .add-exam-title {
      ${fontFamily.sourceSansPro.bold};
      color: ${colors.veryDarkGray};
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 16px;
      text-align: center;

      @media (min-width: ${breakpoints.iphone8.width}px) {
        font-size: 18px;
        line-height: 22px;
      }
    }

    .add-exam-select-institution-wrapper {
      margin: 0 auto;
      max-width: 400px;
    }

    .add-exam-instruction {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.veryDarkGray};
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 40px;
      text-align: center;
    }

    .add-exam-form-container {
      border: dashed 1px ${colors.softBlue};
      border-radius: 12px;
      margin: 0 auto 32px;
      max-width: 400px;
      padding: 36px 0;
      position: relative;
      background-color: transparent;
      transition: background-color 300ms;

      &.active {
        background-color: ${colors.veryPaleBlue};
      }

      .add-exam-form {
        .icon {
          display: block;
          height: 28px;
          left: 32px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 28px;

          @media (min-width: ${breakpoints.iphone8.width}px) {
            height: 36px;
            left: 52px;
            width: 36px;
          }

          svg {
            fill: ${colors.softBlue};
          }
        }

        .form-instruction {
          ${fontFamily.sourceSansPro.bold};
          color: ${colors.softBlue};
          font-size: 16px;
          line-height: 20px;
          text-align: center;
        }

        .input-file-extension {
          ${fontFamily.sourceSansPro.regular};
          color: ${colors.softBlue};
          font-size: 14px;
          line-height: 20px;
          text-align: center;
        }

        .input-file {
          display: block;
          height: 100%;
          left: 0;
          opacity: 0;
          position: absolute;
          top: 0;
          width: 100%;
        }
      }
    }
  }

  .snack-bar-wrapper {
    ${zIndex.hills};
    left: 0;
    position: fixed;
    top: ${headerVariables.main.height.iphone}px;
    width: 100%;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      top: ${headerVariables.main.height.iphone}px;
    }
  }
`;
